<template>
    <div class="inputContainer" :style="{width: width}">
        <div class="iconContainer" :class="{pointer: this.$listeners.click}">
            <span class="icon icon-search"
                  @click="$emit('click')"></span>
        </div>
        <input :value="this.value" placeholder="Suche" v-on:input="$emit('input', $event.target.value)"
               :disabled="disabled" required>
    </div>
</template>

<script>
    export default {
        name: "InputSearch",
        data: function () {
            return {};
        },
        props: {
            disabled: Boolean,
            value: String,
            width: String
        },
        methods: {
            updateValue: function (value) {
                this.$emit('input', value)
            }
        }
    }
</script>

<style lang="scss" scoped>
    .inputContainer {
        display: inline-block;
        position: relative;
    }

    input {
        padding: 0.4em 0.5em 0.4em 2.3em;
        width: 100%;
        font-size: 1em;
        border: 1px solid #dedee0;
    }

    input::placeholder {
        color: #dedee0;
        font-size: 0.9em;
    }

    input:disabled {
        background: transparent;
        border-color: transparent;
        border-bottom: 1px solid #ccc;
        color: black;
    }

    input.iconPadding {
        padding-right: 3em;
    }

    .pointer {
        cursor: pointer;
    }

    .iconContainer {
        position: absolute;
        top: 0;
        left: 0;
        width: 37px;
        height: 100%;
    }

    .icon {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        right: 0;
    }

    .icon:hover {
        color: $pink
    }

    .icon:before {
        display: flex;
        color: #dedee0;
    }

</style>